import React from 'react';
import {Icon} from '../Icon/Icon';
import './styles.css';

interface Props {
  title: string;
  subtitle: string;
  icon?: string;
}

const ProjectsEmptyState = ({
  title,
  subtitle,
  icon = 'projects-menu.svg',
}: Props) => {
  return (
    <div className="EmptyStateContainer">
      <Icon name={icon} className="SpanIcon" />
      <p className="Title">{title}</p>
      <p className="Title">{subtitle}</p>
    </div>
  );
};

export default ProjectsEmptyState;
